export default __webpack_public_path__ + "static/media/cargo_truck.2e71e7ca.svg";